<template>
  <app-layout>
    <div class="bg-white shadow-lg p-4 lg:p-6 lg:py-12 lg:px-16 mx-auto lg:max-w-7xl mb-10">
      <h1 class="text-3xl md:text-5xl mb-8">{{ $trans('app.menu.terms') }}</h1>

      <p>Le site internet accessible à l'adresse www.talents-carriere.fr est exploité et édité par la
        société DSPACE, société par actions simplifiée immatriculée au Registre du Commerce et des Sociétés de
        Bordeaux sous le numéro 903 069 003, dont le siège social est situé au Centre Commercial les Grands
        Hommes, 1er étage, Cs22029, Place des Grands Hommes 33001 Bordeaux Cedex (ci-après "DSPACE").</p>

      <h3>Article 1 – Définitions</h3>

      <p>Les termes et expressions visés ci-après signifient, lorsqu'ils sont précédés par une lettre majuscule,
        pour les besoins de l'interprétation et de l'exécution des présentes Conditions Générales d'Utilisation
        :<br>

        "Compte utilisateur" : compte individuel créé par l’Utilisateur, lui permettant d’accéder et d‘utiliser
        le Service via le Site<br>

        "Conditions Générales d'Utilisation" et/ou "CGU" : les conditions générales d'utilisation du Site
        applicables à tout Utilisateur<br>

        "Données" : Ensemble des informations et données de l’Utilisateur, communiquées par ce dernier à DSPACE
        via le Site, ou disponibles sur des sites internet publics, et/ou générées par l'utilisation du Site
        et/ou traitées par DSPACE<br>

        "Identifiant" : Identifiant propre de chaque Utilisateur ainsi que le mot de passe de connexion lui
        permettant de se connecter à son Compte utilisateur<br>

        "Politique de confidentialité" : la politique de confidentialité accessible à l’adresse suivante :
        https://talents-carriere.fr/privacy-policy<br>

        "Site" : le site internet www.talents-carriere.fr mis à disposition de l’Utilisateur et des
        personnes souhaitant effectuer des tests, contacter le service clients, consulter les CGU notamment<br>

        "Utilisateur" : toute personne physique utilisant le Site</p>

      <h3>Article 2 – Application des Conditions Générales d’Utilisation</h3>

      <p><strong>2.1</strong> Les CGU régissent l’accès et l’utilisation du Site par l’Utilisateur.<br>

        L’Utilisateur confirme avoir lu, compris et accepté l’intégralité des CGU avant toute utilisation du
        Site et s’engage à les respecter.<br>

        En conséquence, l’utilisation du Site entraine l’entière adhésion de l’Utilisateur aux CGU en cochant la
        case prévue à cet effet (reproduisant la phrase : "Je certifie avoir lu et accepté les Conditions
        Générales d'Utilisation").<br>

        <strong>2.2</strong> Les CGU sont susceptibles d'être modifiées à tout moment. L'Utilisateur s'engage à vérifier
        les CGU
        régulièrement et à s'y conformer.<br>

        Le Service est exclusivement dédié à l’utilisation personnelle de l’Utilisateur.</p>

      <h3>Article 3 – Accès au Site</h3>

      <p><strong>3.1</strong> Pour accéder au Site, l'Utilisateur doit disposer d'un accès Internet. DSPACE s'engage à
        mettre en
        œuvre tous les moyens dont elle dispose raisonnablement pour que le Site soit accessible par
        l’Utilisateur à tout moment, 24h/24h et 7j/7, à l'exception des périodes de maintenance.<br>

        En aucun cas DSPACE ne pourra être tenue responsable des ralentissements et/ou interruptions momentanées
        du Site et/ou du Compte utilisateur dus notamment à des raisons techniques, des défaillances ou des
        perturbations des systèmes de télécommunication.<br>

        <strong>3.2</strong> DSPACE peut suspendre ou limiter temporairement l'accès au Site et ce, immédiatement et
        sans
        notification préalable, lorsque DSPACE constate une faille de sécurité de nature à compromettre
        gravement la sécurité de l'accès aux Comptes Utilisateur et/ou des Données et/ou du serveur hébergeant
        le site ou un service tiers.</p>

      <h3>Article 4 – Inscription – Création d'un Compte utilisateur</h3>

      <p><strong>4.1</strong> L’inscription au site et la création d’un Compte utilisateur n’est pas obligatoire pour
        utiliser le
        Site. Toutefois, si l’Utilisateur passe un test, les réponses fournies seront conservées par DSPACE. En
        cas de souscription à une option payante, l’inscription est obligatoire et automatique lors du paiement.
        L’Utilisateur peut à tout moment consulter la Politique de confidentialité afin d’en savoir plus sur la
        gestion des Données.<br>

        DSPACE confirme l’inscription de l’Utilisateur après vérification des Données. Pour ce faire,
        l’Utilisateur reçoit un courrier électronique de confirmation d’inscription à l’adresse de courrier
        électronique communiquée.<br>

        <strong>4.2 </strong>L’Utilisateur est seul responsable des Données et, de manière générale, de l'ensemble des
        contenus présents sur son Compte utilisateur ou qu'il communique via le Site et garantit DSPACE que ces Données
        sont exactes, précises et complètes et qu'elles ne portent atteinte à aucun droit de tiers ni enfreignent aucune
        législation ou règlementation en vigueur.<br>

        L’Utilisateur est seul responsable des dommages résultant de Données incomplètes et/ou mensongères.<br>

        <strong>4.3</strong> L’Utilisateur s'engage à assurer systématiquement la mise à jour des Données.</p>

      <h3>Article 5 – Compte utilisateur</h3>

      <p><strong>5.1</strong> L'Utilisateur garantit à DSPACE que son utilisation du Compte utilisateur et du Service ne
        sera
        contraire à aucune loi ou règlementation en vigueur.<br>

        <strong>5.2</strong> L'Utilisateur est seul responsable de l'utilisation de son Compte utilisateur et de la
        confidentialité des Identifiants. L'Utilisateur s'engage à ne pas laisser des tiers accéder à son Compte
        utilisateur.<br>

        <strong>5.3</strong> L'Utilisateur devra informer DSPACE par courrier électronique à l’adresse
        contact@talents-carriere.fr, s'il constate toute utilisation non autorisée (supposée ou avérée)
        de son Compte utilisateur, une faille ou violation (supposée ou avérée) de sécurité liée notamment à la
        communication volontaire ou non, à la perte ou au détournement d'Identifiants afin que DSPACE puisse
        prendre sans délai toute mesure adaptée en vue de faire remédier à la faille de sécurité.</p>

      <h3>Article 6 – Modalités d’utilisation du Site</h3>

      <p>Afin de bénéficier du Service, l’Utilisateur peut suivre les étapes suivantes :<br>

      <ul>
        <li>Passer le test ;</li>
        <li>Choisir une formule gratuite ou payante ;</li>
        <li>Accéder à ses résultats ;</li>
      </ul>
      OU<br>
      <ul>
        <li>Choisir une formule ;</li>
        <li>Passer le test ;</li>
        <li>Accéder à ses résultats</li>
      </ul>

      Si un paiement est effectué, DPACE crée automatiquement un compte à l’Utilisateur avec l’email fourni
      lors du paiement. Si aucun paiement n’est effectué (choix d’une formule gratuite), les réponses de
      l’utilisateur aux questions sont enregistrées en base de donnée sans les associer à l’Utilisateur.<br>

      En cas de choix de formule gratuite, l’Utilisateur peut accéder à ses résultats en conservant l’url
      (adresse apparaissant dans la barre d’adresse de son navigateur). S’il perd cette url, il ne pourra plus
      accéder à ses résultats. DSPACE ne dispose d’aucun moyen de retrouver les résultats d’une personne ayant
      choisi une formule gratuite.<br>

      Les résultats sont calculés en fonction des réponses fournies par l’Utilisateur. DSPACE ne pourra en
      aucun cas être tenu responsable en cas de mauvaise interprétation des résultats.</p>

      <h3>Article 7 – Conditions tarifaires</h3>

      <p><strong>7.1</strong> Le prix du Service est indiqué sur le Site.<br>

        Les prix affichés incluent les taxes applicables, notamment la TVA, et sont libellés en euros.<br>

        DSPACE se réserve le droit de modifier les prix à tout moment.<br>

        <strong>7.2</strong>Un relevé sera disponible dans le Compte utilisateur dans la rubrique « Mon compte ».</p>

      <h3>Article 8 – Conditions d’annulation</h3>

      <p><strong>8.1</strong> L’Utilisateur a la faculté, sans avoir à justifier ni à payer de frais, de stopper la
        passation d’un
        test en cours lorsqu’il n’a pas payé le prix. Une fois le règlement effectué, aucune annulation ne sera
        possible.<br>

        <strong>8.2</strong> L’Utilisateur déclare renoncer expressément à son droit de rétractation.</p>

      <h3>Article 9 – Résiliation du Compte utilisateur</h3>

      <p><strong>9.1</strong> Résiliation d'un Compte utilisateur par DSPACE :<br>

        DSPACE peut procéder à la fermeture de tout Compte utilisateur, sans préavis ni indemnité, en cas :<br>

      <ul>
        <li>d’utilisation, tentative d'utilisation ou complicité d'utilisation du Site, et/ou du Compte utilisateur,
          en violation notamment d'une loi ou règlement en vigueur ou portant atteinte à un droit de tiers ;
        </li>
        <li>
          d’utilisation du Site, et/ou du Compte utilisateur, en violation des CGU.
        </li>
      </ul>

      <strong>9.2</strong> Résiliation d'un Compte utilisateur par l’Utilisateur :<br>

      L'Utilisateur peut résilier, à tout moment, son Compte utilisateur sous réserve du respect de l'ensemble
      des stipulations des GCU, en adressant une demande en ce sens par courrier électronique à l’adresse
      contact@talents-carriere.fr.<br>

      DSPACE conservera les Données de l’Utilisateur conformément à la Politique de confidentialité.</p>

      <h3>Article 10 – Gestion des Données</h3>

      <p>L’Utilisateur est informé des réglementations concernant la communication marketing, la loi du 21 Juin
        2014 pour la confiance dans l’Economie Numérique, la Loi Informatique et Liberté du 06 Août 2004 ainsi
        que du Règlement Général sur la Protection des Données (RGPD : n° 2016-679).<br>

        Les informations relatives aux Données et les droits de l’Utilisateur sont précisées dans la Politique
        de confidentialité.</p>

      <h3>Article 11 – Propriété intellectuelle</h3>

      <p><strong>11.1</strong> Le Site est la propriété exclusive de DSPACE.<br>

        <strong>11.2</strong> DSPACE est seule titulaire de l'ensemble des droits de propriété intellectuelle afférents
        au Site
        (en ce compris tous ses contenus et fonctionnalités, sa structure générale, les logiciels, textes,
        images animées ou fixes, sons, savoir-faire, créations, dessins, illustrations, logos, éléments
        graphiques, marques et autres signes distinctifs, présentations, articles, fichiers disponibles en
        téléchargement, etc. ; et plus généralement, tous éléments composant le Site) et à la base de données
        (en ce compris son architecture).<br>

        <strong>11.3</strong> L’Utilisateur dispose d’un droit d’usage individuel et privé, non exclusif et
        non-cessible. La
        représentation, la reproduction ou l'exploitation de quelque manière que ce soit de tout ou partie du
        Site, par quelque procédé que ce soit, ainsi que toute utilisation du contenu du Site à d'autres fins
        que la consultation individuelle et privée, sans autorisation expresse et préalable de DSPACE, est
        interdite et constitue une contrefaçon sanctionnée par les articles L. 335-2 et suivants du Code de la
        propriété intellectuelle.<br>

        Sont également notamment interdites l'extraction et la réutilisation, quantitativement ou
        qualitativement substantielles, du contenu de cette base de données. Tout contrevenant s'expose aux
        sanctions visées aux articles L. 343-1 et suivants du Code de la propriété intellectuelle.<br>

        Les CGU n'emportent aucune cession ni aucune licence d'un quelconque droit de propriété intellectuelle
        au profit de l'Utilisateur en dehors du droit d'utiliser le Site conformément à l'ensemble des
        stipulations des CGU.<br>

        <strong>11.4</strong> DSPACE se réserve le droit, sans information préalable de l'Utilisateur, d'améliorer les
        fonctionnalités existantes ou d'ajouter de nouvelles fonctionnalités.</p>

      <h3>Article 12 – Site internet de tiers</h3>

      <p>Le Site peut contenir des liens vers des sites internet tiers et des liens vers des réseaux sociaux, qui
        n'appartiennent pas ni ne sont contrôlés par DSPACE.<br>

        L’Utilisateur ne pourra aucunement mettre en jeu la responsabilité de DSPACE notamment quant au contenu,
        à la politique de confidentialité ou aux pratiques des sites internet et réseaux sociaux de tiers.</p>

      <h3>Article 13 – Divers</h3>

      <p><strong>13.1</strong> Dans l'hypothèse où l'une quelconque des stipulations des CGU serait considérée
        comme étant nulle, illégale ou inopposable par une juridiction compétente ou par une autorité ayant
        compétence pour ce faire, ou en application d'un texte législatif ou réglementaire en vigueur, la
        stipulation contractuelle concernée sera supprimée sans que la validité, ni l'opposabilité des autres
        stipulations des Conditions Générales d'Utilisation en soient affectées.<br>

        <strong>13.2</strong> Le fait pour l’une des parties de ne pas exercer un droit ou de ne pas réclamer à
        l'autre l’exécution d’une obligation incombant à cette dernière en vertu des CGU, ne vaut pas
        renonciation à l'exercice de ce droit ou à l'exécution de cette obligation, non plus qu'exemption de la
        partie défaillante de l'accomplissement à l'avenir de ses obligations.</p>

      <h3>Article 14 – Droit applicable - Litiges</h3>

      <p>Le droit applicable aux CGU est le droit français. Elles sont rédigées en langue française. Dans le cas
        où elles seraient traduites en une ou plusieurs langues, seul le texte français ferait foi en cas de
        litige.<br>

        Toute réclamation ou litige découlant de la validité, de l’interprétation ou de l’exécution des CGU sera
        soumis aux tribunaux compétents du ressort de la Cour d'appel de Bordeaux, dans les conditions de droit
        commun.</p>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import BubbleButton from '@/Components/BubbleButton'
import BubbleLink from '@/Components/BubbleLink'
import ConditionalLink from '@/Components/ConditionalLink'


export default {
  components: {AppLayout, BubbleButton, BubbleLink, ConditionalLink},

  computed: {},

  methods: {}
}
</script>

<style scoped>
h1, h2, h3 {
  @apply text-dark-blue;
}

h2 {
  @apply mt-6 mb-2 ;
}

h3 {
  @apply mt-4 mb-2;
}

p {
  @apply mb-2;
}

li::before {
  @apply ml-4;
  content: "- ";
}
</style>
